export const win = (typeof window == "undefined" ? {} : window) as any;


export const NoOp = () => undefined;